import axios from 'axios'
import { ElMessage, ElNotification } from 'element-plus'

let instance = axios.create({
    baseURL: process.env.NODE_ENV == 'production' ? '' : 'http://192.168.1.10:8081'
})

let token = localStorage.getItem('token')
instance.interceptors.request.use((config)=>{
    if(token) {
        config.headers.Authorization = 'Bearer ' + token
    }

    return config
})
instance.interceptors.response.use((response)=>{
    // if(response.config.url == '/logout' && response.data.success){
    //     localStorage.clear();
    //     location.href = '/'
    // }
    if(Reflect.has(response.data, 'msg')) {
        if(response.data.type == 'error') {
            ElMessage.error(response.data.msg)
        }else {
            ElMessage.info(response.data.msg)
        }
    }
    if(response.data.token) {
        localStorage.setItem('token', response.data.token)
        location.href = '/'
    }
    if(response.data.msg == '登录信息无效'){
        window.localStorage.removeItem('token');
        window.location.href = '/'
    }
    return response
},()=>{
    ElNotification({
        type: "error",
        title: '網絡錯誤',
        message: "請求中出現錯誤"
    })
})

export default instance